const SCHEDULED_STUDY_TYPE_OTHERS = {
  value: 0,
  label: 'その他の技術',
};

const REDIRECT_LINK = 'https://www.sejuku.net/terakoya/thanks/';

export { SCHEDULED_STUDY_TYPE_OTHERS, REDIRECT_LINK };
